/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContractInvoiceRateType {
    FLAT_RATE = 'FLAT_RATE',
    ACTION = 'ACTION',
    MAX_RATE = 'MAX_RATE',
}
